/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Rows_With_ErrorsInputs */



/**
* | output |
* | --- |
* | "{count} rows had errors" |
*
* @param {Knp_Terms_Rows_With_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_rows_with_errors = /** @type {((inputs: Knp_Terms_Rows_With_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Rows_With_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} lignes comportaient des erreurs`)
	if (locale === "de") return /** @type {LocalizedString} */ (`In den Zeilen ${i?.count} traten Fehler auf.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} righe contenevano errori`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`В строках ${i?.count} были обнаружены ошибки.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} filas tenían errores`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 行存在错误`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 行にエラーがありました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} पंक्तियों में त्रुटियाँ थीं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} linhas continham erros`)
	return /** @type {LocalizedString} */ (`${i?.count} rows had errors`)
});